import { Injectable } from '@angular/core';
import { DeliveryWindowItem } from '@libs/shared/models';
import { DateTime } from 'luxon';
import { map, Observable } from 'rxjs';
import { DeliveryInfoRepositoryService } from './delivery-info-repository.service';
import { deliveryCategoryLabels } from './delivery-info.i18n';

@Injectable({
  providedIn: 'root',
})
export class DeliveryInfoService {
  public constructor(
    private readonly deliveryInfoRepo: DeliveryInfoRepositoryService,
  ) {
  }

  public getDeliveryWindows(dateFrom: DateTime, dateTo?: DateTime): Observable<DeliveryWindowItem[]> {
    return this.deliveryInfoRepo.getDeliveryWindows(dateFrom, dateTo).pipe(map((windows) => {
      const dateCategoryMap: Record<string, string[]> = {};
      const dateOrderDeadlineMap: Record<string, DateTime> = {};
      const viewItems: DeliveryWindowItem[] = [];

      for (const item of windows) {
        // we only show the next delivery date of each category
        const date: string | null = DateTime.fromISO(item.date).toISODate();

        if (!date) {
          continue;
        }

        const categoryName: string = deliveryCategoryLabels[item.category] ?? item.category;

        if (!dateCategoryMap[date]) {
          dateCategoryMap[date] = [categoryName];
        } else {
          dateCategoryMap[date].push(categoryName);
        }

        dateOrderDeadlineMap[date] = DateTime.fromISO(item.orderDeadline);
      }

      for (const date of Object.keys(dateCategoryMap)) {
        const categories: string = dateCategoryMap[date].sort().join(', ');

        viewItems.push({
          category: categories,
          date: DateTime.fromISO(date),
          orderDeadline: dateOrderDeadlineMap[date],
        });
      }

      return viewItems;
    }));
  }
}
